import { useEffect, useMemo, useState } from 'react';
import { launchApi } from '../api';
import { YearbookProductMatch, YearbookSheet } from '../types';

export function useYearbookProducts(sheet: YearbookSheet | null, refresh = 0) {
  const [matches, setMatches] = useState<Record<string, YearbookProductMatch>>({});
  const [failed, setFailed] = useState(false);
  const sheetId = sheet?.id ?? '';
  const signature = useMemo(
    () => (sheet ? sheet.rows.map((row) => `${row.id}:${row.articleNumber}:${row.assetId ?? ''}`).join('|') : ''),
    [sheet],
  );

  useEffect(() => {
    if (!sheetId) {
      setMatches({});
      return undefined;
    }
    let cancelled = false;
    launchApi.yearbookProducts(sheetId)
      .then((found) => {
        if (cancelled) return;
        setMatches(found);
        setFailed(false);
      })
      .catch(() => {
        if (!cancelled) setFailed(true);
      });
    return () => { cancelled = true; };
  }, [refresh, sheetId, signature]);

  return { matches, failed };
}
